// extracted by mini-css-extract-plugin
export default {"idBody":"Inactive_idBody__dmpPE","id":"Inactive_id__hiv3z"};